import { createSlice } from '@reduxjs/toolkit';
import { RootState } from '@/lib/stores/store';
export type CandleStickTickData = {
  time: number;
  open: number;
  high: number;
  low: number;
  close: number;
  volume: number;
};
export type PumpFunListItem = {
  token: string;
  icon: string;
  progress: number;
  holder: number;
  marketCap: number;
  devStatus: string;
};
type DataState = {
  candleStickTickData?: CandleStickTickData;
  solanaPrice: number;
  pumpFun: {
    recentlyCreated: PumpFunListItem[];
    completing: PumpFunListItem[];
    completed: PumpFunListItem[];
  };
  needReload: boolean
};
const dataInitState: DataState = {
  solanaPrice: -1,
  pumpFun: {
    recentlyCreated: [],
    completed: [],
    completing: [],
  },
  needReload: false,
};
const dataSlice = createSlice({
  name: 'data',
  initialState: dataInitState,
  reducers: {
    setCandleStickTickData: (
      state,
      action: { payload: CandleStickTickData },
    ) => {
      state.candleStickTickData = action.payload;
    },
    setSolanaPrice: (state, action: { payload: number }) => {
      state.solanaPrice = action.payload;
    },
    setPumpFunList: (
      state,
      action: {
        payload: {
          type: 'recentlyCreated' | 'completing' | 'completed';
          list: PumpFunListItem[];
        };
      },
    ) => {
      state.pumpFun[action.payload.type] = action.payload.list;
    },
    setNeedReload: (state, action: { payload: boolean }) => {
      console.log('payload', action)
      state.needReload = action.payload;
    },
  },
});
export const reduxCandleStickTickData = (state: RootState) =>
  state.data.candleStickTickData;
export const reduxPumpFunList = (state: RootState) => state.data.pumpFun;
export const reduxNeedReload = (state: RootState) => state.data.needReload;
export const reduxSolanaPrice = (state: RootState) => state.data.solanaPrice;
export const { setCandleStickTickData, setPumpFunList, setSolanaPrice, setNeedReload } =
  dataSlice.actions;

export default dataSlice.reducer;
